export const keyStorageMainBackground = 'mainBackground:selectedMainBackgroundv2';
